var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridiconsNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 0C18.408 0 0.5 17.908 0.5 40C0.5 62.092 18.408 80 40.5 80C62.592 80 80.5 62.092 80.5 40C80.5 17.908 62.592 0 40.5 0ZM44.5 60H36.5V52H44.5V60ZM44.5 44H36.5L34.5 20H46.5L44.5 44Z",
    fill: "#FF2C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsNotice);
export default __webpack_public_path__ + "static/media/gridicons_notice.21e3cd297c7a0725b9f853b9e503d42f.svg";
export { ForwardRef as ReactComponent };